import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
  Stack,
} from "@mui/material";
import { updateStockSelection } from "../../../../services/leaderBoard";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import gainIcon from "../../../../styles/images/gain_icon.svg";
import lossIcon from "../../../../styles/images/loss_icon.svg";
import { localStorageInstance } from "../../../../utils/storage";

export const CurrentWeekTable = ({ data, refetch }) => {
  const [timeLeft, setTimeLeft] = useState(20 * 60);

  useEffect(() => {
    if (timeLeft <= 0) {
      handleTimerEnd();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft(prevTime => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const handleTimerEnd = () => {
    setTimeLeft(20 * 60);
    refetch();
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const emptyRow = [{
    player_name: "No players yet",
    rank: "-",
    days: [],
    user_id: null
  }];
  const playersToRender = data.players.length > 0 ? data.players : emptyRow;
  const [selectedStocks, setSelectedStocks] = useState({});
  const { seasonId } = useParams();
  const handleStockChange = async (
    dayKey,
    day,
    stock_selection_id,
    stockValue,
    player
  ) => {
    try {
      // setLoading(true);
      let res = await updateStockSelection(
        stock_selection_id,
        parseInt(seasonId),
        data.week,
        day.day,
        stockValue,
        player.user_id
      );
      refetch();
      console.log("response print === ", res);
      toast.success(res.message);
      // setRefetch(!refetch);
      // setLoading(false);
      // setCreateLeague(false);
      // methods.reset();
    } catch (err) {
      console.log("err === ", err);
      toast.error(err);
      // toast.error(err);
      // setLoading(false);
    }

    // setSelectedStocks((prev) => ({
    //   ...prev,
    //   [dayKey]: stockValue,
    // }));
  };

  const borderStyle = {
    borderLeft: "1px solid rgba(224, 224, 224, 1)",
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  };

  let currentUserId = localStorageInstance.getItem("user_id")

  const myRank = data.players.find(player => player.user_id === currentUserId)?.rank

  const isCurrentWeekDayGreaterThanToday = (currentWeekDay) => {
    const today = new Date().getDay();
    return currentWeekDay > today;
  };

  const getWeekDayNumber = (day) => {
    const weekDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    return weekDays.indexOf(day);
  };
console.log("week table ===== ",data)
console.log("week status ===== ",data?.week_type, data?.week_type == 'Semifinal')
  return (
    <Box className="current_week_table_cont">
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6">
          Week {data.week} - {data.theme}
          <span className="theme-rank">{`${myRank ? 'My Rank #' + myRank : ""}`}</span>
        </Typography>
        <Typography variant="h6" color="primary">
        Inventory Update Time: {formatTime(timeLeft)}
        </Typography>
      </Stack>

      {data?.week_type == 'Semifinal' ?
        <>
          <TableContainer component={Paper} sx={{ maxWidth: "100%" }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
                  <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                    Rank
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", ...borderStyle, width: "250px" }}>
                    Player
                  </TableCell>
                  {/* Create a column for each day in the data */}
                  {["MON", "TUE", "WED", "THU", "FRI"].map((day) => (
                    <TableCell key={day} sx={{ fontWeight: "bold" }}>
                      {day}
                    </TableCell>
                  ))}
                  <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                    Total
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                    Season Score
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.matchups?.match1?.map(matchup => data?.players?.find(player => player?.user_id === matchup)).map((player) => (
                  <TableRow key={player.player_name}>
                    <TableCell sx={{ ...borderStyle }}>
                      <Typography variant="body2" fontWeight="bold">
                        {player.rank}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ ...borderStyle }}>
                      <Typography variant="body2" fontWeight="bold">
                        {player.player_name}
                      </Typography>
                    </TableCell>
                    {player.days
                      ? // Regular row with data
                      player.days.map((day) => (
                        <TableCell
                          key={day.day}
                          sx={{
                            verticalAlign: "top",
                            ...borderStyle,
                            padding: "0px !important",
                          }}
                        >
                          <div className="stock-cell">
                            {day.stocks.length === 0
                              ? Array.from({ length: 3 }).map((_, index) => (
                                <Typography
                                  key={index}
                                  variant="caption"
                                  component="div"
                                >
                                  ----
                                </Typography>
                              ))
                              : day.daily_gain_loss === "" && player.user_id === currentUserId
                                ? day.stocks.map(
                                  (
                                    { stock, stock_selection_id },
                                    stockIndex
                                  ) => {
                                    return <div key={`${day.day}-${stockIndex}`}>
                                      <FormControl
                                        variant="standard"
                                        size="small"
                                        fullWidth
                                      >
                                        <Select
                                          labelId={`select-label-${day.day}-${stockIndex}`}
                                          id={`select-${day.day}-${stockIndex}`}
                                          value={
                                            selectedStocks[
                                            `${player.player_name}-${day.day}-${stockIndex}`
                                            ] || stock
                                          }
                                          onChange={(event) =>
                                            handleStockChange(
                                              `${player.player_name}-${day.day}-${stockIndex}`,
                                              day,
                                              stock_selection_id,
                                              event.target.value,
                                              player
                                            )
                                          }
                                          sx={{
                                            padding: "0px 18px !important",
                                            color: "#212b36b2",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                            "&:before": {
                                              borderBottom: "none",
                                            },
                                            width: "100%",
                                          }}
                                        >
                                          {data.theme_stocks.map((value) => (
                                            <MenuItem key={value} value={value} sx={{
                                              color: "#212b36b2",
                                              fontSize: "12px",
                                              fontWeight: "400",
                                            }}>
                                              {value}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  }
                                )
                                : day.stocks.map((stock, index) =>
                                  stock.stock ? (
                                    !isCurrentWeekDayGreaterThanToday(getWeekDayNumber(day?.day)) && <div key={index} className="stock-item">
                                      <span className="stock-name">
                                        {stock.stock}
                                      </span>
                                      <span
                                        className={`stock-value ${stock.trend}`}
                                      >
                                        {stock.daily_gain_loss}
                                      </span>
                                      {stock?.daily_gain_loss && (
                                        <img
                                          src={
                                            stock?.daily_gain_loss?.startsWith(
                                              "-"
                                            )
                                              ? lossIcon
                                              : gainIcon
                                          }
                                        />
                                      )}
                                    </div>
                                  ) : (
                                    ""
                                  )
                                )}
                            {day.daily_gain_loss !== "" && <div className="stock-item-result ">
                              <span className={`stock-value`}>
                                {day.daily_gain_loss}
                              </span>
                              <img
                                src={
                                  day?.daily_gain_loss?.startsWith("-")
                                    ? lossIcon
                                    : gainIcon
                                }
                              />
                            </div>}
                          </div>
                        </TableCell>
                      ))
                      : // Empty cells for days
                      ["MON", "TUE", "WED", "THU", "FRI"].map((day) => (
                        <TableCell sx={{ ...borderStyle }} key={day}>
                          -
                        </TableCell>
                      ))}
                    <TableCell
                      sx={{
                        color: player?.weekly_gain_loss?.startsWith("-")
                          ? "red"
                          : player.weekly_gain_loss === "-"
                            ? "inherit"
                            : "green",
                        fontWeight: "bold",
                        ...borderStyle,
                      }}
                    >
                      {player.weekly_gain_loss || "---"}
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                      {player?.season_score === null ? "---" : player?.season_score}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>


          {data?.matchups?.match2?.length > 0 && <TableContainer component={Paper} sx={{ maxWidth: "100%", mt: 4 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
                  <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                    Rank
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", ...borderStyle, width: "250px" }}>
                    Player
                  </TableCell>
                  {/* Create a column for each day in the data */}
                  {["MON", "TUE", "WED", "THU", "FRI"].map((day) => (
                    <TableCell key={day} sx={{ fontWeight: "bold" }}>
                      {day}
                    </TableCell>
                  ))}
                  <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                    Total
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                    Season Score
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.matchups?.match2?.map(matchup => data?.players?.find(player => player?.user_id === matchup)).map((player) => (
                  <TableRow key={player.player_name}>
                    <TableCell sx={{ ...borderStyle }}>
                      <Typography variant="body2" fontWeight="bold">
                        {player.rank}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ ...borderStyle }}>
                      <Typography variant="body2" fontWeight="bold">
                        {player.player_name}
                      </Typography>
                    </TableCell>
                    {player.days
                      ? // Regular row with data
                      player.days.map((day) => (
                        <TableCell
                          key={day.day}
                          sx={{
                            verticalAlign: "top",
                            ...borderStyle,
                            padding: "0px !important",
                          }}
                        >
                          <div className="stock-cell">
                            {day.stocks.length === 0
                              ? Array.from({ length: 3 }).map((_, index) => (
                                <Typography
                                  key={index}
                                  variant="caption"
                                  component="div"
                                >
                                  ----
                                </Typography>
                              ))
                              : day.daily_gain_loss === "" && player.user_id === currentUserId
                                ? day.stocks.map(
                                  (
                                    { stock, stock_selection_id },
                                    stockIndex
                                  ) => {
                                    return <div key={`${day.day}-${stockIndex}`}>
                                      <FormControl
                                        variant="standard"
                                        size="small"
                                        fullWidth
                                      >
                                        <Select
                                          labelId={`select-label-${day.day}-${stockIndex}`}
                                          id={`select-${day.day}-${stockIndex}`}
                                          value={
                                            selectedStocks[
                                            `${player.player_name}-${day.day}-${stockIndex}`
                                            ] || stock
                                          }
                                          onChange={(event) =>
                                            handleStockChange(
                                              `${player.player_name}-${day.day}-${stockIndex}`,
                                              day,
                                              stock_selection_id,
                                              event.target.value,
                                              player
                                            )
                                          }
                                          sx={{
                                            padding: "0px 18px !important",
                                            color: "#212b36b2",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                            "&:before": {
                                              borderBottom: "none",
                                            },
                                            width: "100%",
                                          }}
                                        >
                                          {data.theme_stocks.map((value) => (
                                            <MenuItem key={value} value={value} sx={{
                                              color: "#212b36b2",
                                              fontSize: "12px",
                                              fontWeight: "400",
                                            }}>
                                              {value}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  }
                                )
                                : day.stocks.map((stock, index) =>
                                  stock.stock ? (
                                    !isCurrentWeekDayGreaterThanToday(getWeekDayNumber(day?.day)) && <div key={index} className="stock-item">
                                      <span className="stock-name">
                                        {stock.stock}
                                      </span>
                                      <span
                                        className={`stock-value ${stock.trend}`}
                                      >
                                        {stock.daily_gain_loss}
                                      </span>
                                      {stock?.daily_gain_loss && (
                                        <img
                                          src={
                                            stock?.daily_gain_loss?.startsWith(
                                              "-"
                                            )
                                              ? lossIcon
                                              : gainIcon
                                          }
                                        />
                                      )}
                                    </div>
                                  ) : (
                                    ""
                                  )
                                )}
                            {day.daily_gain_loss !== "" && <div className="stock-item-result ">
                              <span className={`stock-value`}>
                                {day.daily_gain_loss}
                              </span>
                              <img
                                src={
                                  day?.daily_gain_loss?.startsWith("-")
                                    ? lossIcon
                                    : gainIcon
                                }
                              />
                            </div>}
                          </div>
                        </TableCell>
                      ))
                      : // Empty cells for days
                      ["MON", "TUE", "WED", "THU", "FRI"].map((day) => (
                        <TableCell sx={{ ...borderStyle }} key={day}>
                          -
                        </TableCell>
                      ))}
                    <TableCell
                      sx={{
                        color: player?.weekly_gain_loss?.startsWith("-")
                          ? "red"
                          : player.weekly_gain_loss === "-"
                            ? "inherit"
                            : "green",
                        fontWeight: "bold",
                        ...borderStyle,
                      }}
                    >
                      {player.weekly_gain_loss || "---"}
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                      {player?.season_score === null ? "---" : player?.season_score}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>}
        </>

        :
        <TableContainer component={Paper} sx={{ maxWidth: "100%" }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
                <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                  Rank
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                  Player
                </TableCell>
                {/* Create a column for each day in the data */}
                {["MON", "TUE", "WED", "THU", "FRI"].map((day) => (
                  <TableCell key={day} sx={{ fontWeight: "bold" }}>
                    {day}
                  </TableCell>
                ))}
                <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                  Total
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                  Season Score
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {playersToRender.map((player) => (
                <TableRow key={player.player_name}>
                  <TableCell sx={{ ...borderStyle }}>
                    <Typography variant="body2" fontWeight="bold">
                      {player.rank}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ ...borderStyle }}>
                    <Typography variant="body2" fontWeight="bold">
                      {player.player_name}
                    </Typography>
                  </TableCell>
                  {player.days
                    ? // Regular row with data
                    player.days.map((day) => (
                      <TableCell
                        key={day.day}
                        sx={{
                          verticalAlign: "top",
                          ...borderStyle,
                          padding: "0px !important",
                        }}
                      >
                        <div className="stock-cell">
                          {day.stocks.length === 0
                            ? Array.from({ length: 3 }).map((_, index) => (
                              <Typography
                                key={index}
                                variant="caption"
                                component="div"
                              >
                                ----
                              </Typography>
                            ))
                            : day.daily_gain_loss === "" && player.user_id === currentUserId
                              ? day.stocks.map(
                                (
                                  { stock, stock_selection_id },
                                  stockIndex
                                ) => {
                                  return <div key={`${day.day}-${stockIndex}`}>
                                    <FormControl
                                      variant="standard"
                                      size="small"
                                      fullWidth
                                    >
                                      <Select
                                        labelId={`select-label-${day.day}-${stockIndex}`}
                                        id={`select-${day.day}-${stockIndex}`}
                                        value={
                                          selectedStocks[
                                          `${player.player_name}-${day.day}-${stockIndex}`
                                          ] || stock
                                        }
                                        onChange={(event) =>
                                          handleStockChange(
                                            `${player.player_name}-${day.day}-${stockIndex}`,
                                            day,
                                            stock_selection_id,
                                            event.target.value,
                                            player
                                          )
                                        }
                                        sx={{
                                          padding: "0px 18px !important",
                                          color: "#212b36b2",
                                          fontSize: "12px",
                                          fontWeight: "400",
                                          "&:before": {
                                            borderBottom: "none",
                                          },
                                          width: "100%",
                                        }}
                                      >
                                        {data.theme_stocks.map((value) => (
                                          <MenuItem key={value} value={value} sx={{
                                            color: "#212b36b2",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}>
                                            {value}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </div>
                                }
                              )
                              : day.stocks.map((stock, index) =>
                                stock.stock ? (
                                  !isCurrentWeekDayGreaterThanToday(getWeekDayNumber(day?.day)) && <div key={index} className="stock-item">
                                    <span className="stock-name">
                                      {stock.stock}
                                    </span>
                                    <span
                                      className={`stock-value ${stock.trend}`}
                                    >
                                      {stock.daily_gain_loss}
                                    </span>
                                    {stock?.daily_gain_loss && (
                                      <img
                                        src={
                                          stock?.daily_gain_loss?.startsWith(
                                            "-"
                                          )
                                            ? lossIcon
                                            : gainIcon
                                        }
                                      />
                                    )}
                                  </div>
                                ) : (
                                  ""
                                )
                              )}
                          {day.daily_gain_loss !== "" && <div className="stock-item-result ">
                            <span className={`stock-value`}>
                              {day.daily_gain_loss}
                            </span>
                            <img
                              src={
                                day?.daily_gain_loss?.startsWith("-")
                                  ? lossIcon
                                  : gainIcon
                              }
                            />
                          </div>}
                        </div>
                      </TableCell>
                    ))
                    : // Empty cells for days
                    ["MON", "TUE", "WED", "THU", "FRI"].map((day) => (
                      <TableCell sx={{ ...borderStyle }} key={day}>
                        -
                      </TableCell>
                    ))}
                  <TableCell
                    sx={{
                      color: player?.weekly_gain_loss?.startsWith("-")
                        ? "red"
                        : player.weekly_gain_loss === "-"
                          ? "inherit"
                          : "green",
                      fontWeight: "bold",
                      ...borderStyle,
                    }}
                  >
                    {player.weekly_gain_loss || "---"}
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                    {player?.season_score === null ? "---" : player?.season_score}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      }
    </Box>
  );
};
